/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import get from "lodash/get";
import React from "react";
import { shallowEqual, useSelector } from "react-redux";

const WithArrowConfig = Component => ({ collection = {}, config = {}, index, updateAdAndWidgetComponent }) => {
  const pageType = useSelector(state => get(state, ["qt", "pageType"], ""), shallowEqual);
  const supportedPages = {
    "home-page": "home",
    "section-page": "section",
    "collection-page": "section",
    "tag-page": "tag",
    "author-page": "author",
    "pagebuilder-section-preview-page": "section",
    "pagebuilder-collection-preview-page": "section",
    "pagebuilder-story-preview-page": "story",
    "authors-page": "authors",
    "": ""
  };
  const theme = useSelector(
    state => get(state, ["qt", "config", "pagebuilder-config", supportedPages[pageType], "pageSetting", "bgColor"], ""),
    shallowEqual
  );
  const { "pagebuilder-config": pbconfig, "theme-attributes": themeAttributes } = useSelector(state =>
    get(state, ["qt", "config"])
  );
  const fallbackImageUrl = get(
    pbconfig,
    ["general", "fallbackImage", "url"],
    get(themeAttributes, ["imageFallbackUrl"])
  );

  const updateConfig = (config = {}) => {
    const pbRowsConfig = useSelector(state =>
      get(state, ["qt", "config", "pagebuilder-config", "general", "rows"], {})
    );
    const { enablePremiumStoryIcon = false, iconColor, iconStyle = "star" } = get(
      pbRowsConfig,
      ["premiumStoryIcon"],
      {}
    );
    const premiumStoryIconConfig = { enablePremiumStoryIcon, iconColor, iconStyle };
    const collectionNameTemplate = get(pbRowsConfig, ["collectionNameTemplate"], "");
    const borderColor = get(pbRowsConfig, ["sectionTag", "color"], ""); // borderColor to change sectionTag color. TODO: rename to sectionTagColor
    const collectionNameBorderColor = get(pbRowsConfig, ["titleStyle", "underLineColor"], "");
    const supportedPagesForTitle = ["author-page", "tag-page"];
    const pages = supportedPagesForTitle.includes(pageType);

    // Arrow needs the config values like sectionTagTemplate directly under config prop.
    // TODO: May need to flatten the rowConfig sometime.
    const sectionTagTemplate = get(
      pbRowsConfig,
      ["sectionTag", "template"],
      get(pbRowsConfig, ["sectionTagTemplate"], "solid")
    );

    const updatedConfig = {
      theme,
      ...config,
      ...collection.config, // collection.config is available only from section page when it is collectionOfStories.
      sectionTagTemplate,
      collectionNameTemplate,
      borderColor,
      collectionNameBorderColor,
      fallbackImageUrl,
      ...premiumStoryIconConfig,
      ...(pages && { showRowTitle: false })
    };

    if (updateAdAndWidgetComponent) {
      return updateAdAndWidgetComponent(updatedConfig);
    }

    return updatedConfig;
  };

  return <Component collection={collection} config={updateConfig(config)} index={index} />;
};
export default WithArrowConfig;
